import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import {
  FaAngleDown,
  FaFolderOpen,
  FaAngleUp,
  FaArrowCircleDown,
  FaArrowCircleUp,
} from "react-icons/fa";
import AddPopOver from "./AddPopOver";
import EditPopOver from "./EditPopOver";
import {
  addMenu,
  editMenu,
  orderUpMenu,
  orderDownMenu,
} from "app/services/menuService";
import DeletePopOver from "./DeletePopOver";
import { Col, Row } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import ViewPopOver from "./ViewPopOver";
import { memo } from "react";
import usePagePermission from "app/hooks/usePagePermission";
import Tooltip from "rc-tooltip";

const MenuItem = ({
  item,
  setMenuState,
  menuState,
  disableDownOrder,
  disableUpOrder,
  isCollapseAll,
}) => {
  const { canView, canAdd, canEdit, canDelete } = usePagePermission();

  const { id, name, childMenus, orderNo } = item;

  const [isCollapsed, setIsCollapsed] = useState(false);

  const [isShow, setIsShow] = useState(false);
  const [isEditShow, setIsEditShow] = useState(false);

  const [target, setTarget] = useState(null);
  const [editTarget, setEditTarget] = useState(null);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [isDeleteShow, setIsDeleteShow] = useState(false);

  const [viewTarget, setViewTarget] = useState(null);
  const [isViewShow, setIsViewShow] = useState(false);

  const handleCollapseToggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const value = {
      name: e.target.name.value,
      icon: e.target.icon.value,
      path: e.target.path?.value,
      description: e.target.description.value,
    };

    const newMenu = await addMenu(id, value);
    setMenuState(newMenu.data);
    setIsShow(false);
    NotificationManager.success(newMenu.message);
  };
  const activeSubmit = async (e) => {
    e.preventDefault();

    const value = {
      isActive: e.target.checked,

      name: item.name,
      icon: item.icon,
      path: item.path,
      description: item.description,
    };

    const editedMenu1 = await editMenu(id, value);
    setMenuState(editedMenu1.data);
    // setIsEditShow(false);
    NotificationManager.success(editedMenu1.message);
  };

  const editSubmit = async (e) => {
    e.preventDefault();
    const value = {
      name: e.target.name.value,
      icon: e.target.icon.value,
      path: e.target.path?.value,
      isActive: e.target.isActive.checked,
      description: e.target.description.value,
    };

    const editedMenu = await editMenu(id, value);
    setMenuState(editedMenu.data);
    setIsEditShow(false);
    NotificationManager.success(editedMenu.message);
  };

  const upOrderHandler = async () => {
    const upData = await orderUpMenu(id);
    setMenuState(upData.data);

    NotificationManager.success(upData.message);
  };

  const downOrderHandler = async () => {
    const downData = await orderDownMenu(id);
    setMenuState(downData.data);
    NotificationManager.success(downData.message);
  };

  useEffect(() => {
    if (isCollapseAll != 0) {
      setIsCollapsed(true);
    }
  }, [isCollapseAll]);

  return item ? (
    <div className="mainItemSection mx-0">
      <Row>
        <Col xs={12} lg={6}>
          <Row className="menuRow">
            <Col xs={6} lg={8}>
              <div
                className={`d-flex text-primary my-2 cursor-pointer ${
                  isCollapsed ? "collapsed" : ""
                }`}
                onClick={handleCollapseToggle}
              >
                {childMenus.length > 0 ? (
                  isCollapsed ? (
                    <FaAngleUp className="me-2 mt-1" />
                  ) : (
                    <FaAngleDown className="me-2 mt-1" />
                  )
                ) : (
                  <span style={{ marginRight: "20px" }}>
                    <FaAngleUp className="d-none" />
                  </span>
                )}

                {name}
              </div>
            </Col>
            <Col xs={6} lg={4}>
              <div className="d-flex float-end">
                <AddPopOver
                  target={target}
                  setTarget={setTarget}
                  setIsShow={setIsShow}
                  isShow={isShow}
                  id={item.id}
                  handleSubmit={handleSubmit}
                />

                <ViewPopOver
                  viewTarget={viewTarget}
                  setViewTarget={setViewTarget}
                  setIsViewShow={setIsViewShow}
                  isViewShow={isViewShow}
                  id={item.id}
                  item={item}
                  parent="parent"
                />

                {item && (
                  <EditPopOver
                    editTarget={editTarget}
                    setEditTarget={setEditTarget}
                    setIsEditShow={setIsEditShow}
                    isEditShow={isEditShow}
                    id={item.id}
                    item={item}
                    setMenuState={setMenuState}
                    handleSubmit={editSubmit}
                    parent="parent"
                    childMenus={childMenus}
                  />
                )}
                <DeletePopOver
                  id={item.id}
                  item={item}
                  deleteTarget={deleteTarget}
                  setDeleteTarget={setDeleteTarget}
                  setIsDeleteShow={setIsDeleteShow}
                  isDeleteShow={isDeleteShow}
                  setMenuState={setMenuState}
                  menuState={menuState}
                  parent="parent"
                />
                {canEdit && (
                  <>
                    <button
                      className="btn btn-link btn-xs"
                      type="button"
                      disabled={disableDownOrder}
                      onClick={() => downOrderHandler(id)}
                    >
                      <FaArrowCircleDown />
                    </button>

                    <button
                      className="btn btn-link btn-xs"
                      type="button"
                      disabled={disableUpOrder}
                      onClick={() => upOrderHandler(id)}
                    >
                      <FaArrowCircleUp />
                    </button>
                    <Tooltip
                      placement="top"
                      overlay={
                        <span>
                          {" "}
                          {item?.isActive ? "Deactivate Menu" : "Active Menu"}
                        </span>
                      }
                    >
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckDefault"
                          name="item?.isActive"
                          checked={item?.isActive}
                          onChange={(e) => activeSubmit(e)}
                          style={{ marginTop: "10px" }}
                        />
                      </div>
                    </Tooltip>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Col>
        <Col lg={6}></Col>
      </Row>

      {childMenus && (
        <div className={` ${isCollapsed ? "d-none" : ""}`}>
          {childMenus.map((subitem, index) => {
            return (
              <Subitem
                disableUpOrder={index == 0}
                disableDownOrder={childMenus.length == index + 1}
                key={subitem.id}
                subitem={subitem}
                setMenuState={setMenuState}
                menuState={menuState}
              />
            );
          })}
        </div>
      )}
    </div>
  ) : (
    <></>
  );
};

MenuItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    childMenus: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

//#region Sub menu

const Subitem = ({
  subitem,

  setMenuState,
  menuState,
  disableDownOrder,
  disableUpOrder,
}) => {
  const { canView, canAdd, canEdit, canDelete } = usePagePermission();
  const [isEditShow, setIsEditShow] = useState(false);
  const [editTarget, setEditTarget] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [isDeleteShow, setIsDeleteShow] = useState(false);

  const [viewTarget, setViewTarget] = useState(null);
  const [isViewShow, setIsViewShow] = useState(false);

  const { id, name, orderNo, childMenus } = subitem;

  const editSubmit = async (e) => {
    e.preventDefault();
    const value = {
      name: e.target.name.value,
      icon: e.target.icon.value,
      path: e.target.path?.value,
      isActive: e.target.isActive.checked,

      description: e.target.description.value,
    };

    const newMenu = await editMenu(id, value);
    setMenuState(newMenu.data);
    setIsEditShow(false);
  };

  const upOrderHandler = async () => {
    const upData = await orderUpMenu(id);
    setMenuState(upData.data);

    NotificationManager.success(upData.message);
  };

  const downOrderHandler = async () => {
    const downData = await orderDownMenu(id);
    setMenuState(downData.data);
    NotificationManager.success(downData.message);
  };
  const activeSubmit = async (e) => {
    e.preventDefault();

    const value = {
      isActive: e.target.checked,

      name: subitem.name,
      icon: subitem.icon,
      path: subitem.path,
      description: subitem.description,
    };

    const editedMenu1 = await editMenu(id, value);
    setMenuState(editedMenu1.data);
    // setIsEditShow(false);
    NotificationManager.success(editedMenu1.message);
  };

  return (
    <div className="pt-1">
      <Row>
        <Col xs={12} lg={6}>
          <Row className="menuRow">
            <Col xs={8} lg={8}>
              <div className="d-flex pl-4">
                <FaFolderOpen className="ms-3 me-2 mt-1" />
                {name}
              </div>
            </Col>

            <Col xs={4} lg={4}>
              <div className="d-flex float-end">
                {subitem && (
                  <>
                    <ViewPopOver
                      viewTarget={viewTarget}
                      setViewTarget={setViewTarget}
                      setIsViewShow={setIsViewShow}
                      isViewShow={isViewShow}
                      id={subitem.id}
                      item={subitem}
                    />
                    <EditPopOver
                      editTarget={editTarget}
                      setEditTarget={setEditTarget}
                      setIsEditShow={setIsEditShow}
                      isEditShow={isEditShow}
                      id={subitem.id}
                      item={subitem}
                      setMenuState={setMenuState}
                      handleSubmit={editSubmit}
                      childMenus={childMenus}
                    />

                    <DeletePopOver
                      id={subitem.id}
                      item={subitem}
                      deleteTarget={deleteTarget}
                      setDeleteTarget={setDeleteTarget}
                      setIsDeleteShow={setIsDeleteShow}
                      isDeleteShow={isDeleteShow}
                      setMenuState={setMenuState}
                      menuState={menuState}
                    />

                    {canEdit && (
                      <>
                        <button
                          className="btn btn-link btn-xs"
                          type="button"
                          disabled={disableDownOrder}
                          onClick={() => downOrderHandler(id)}
                        >
                          <FaArrowCircleDown />
                        </button>

                        <button
                          className="btn btn-link btn-xs"
                          type="button"
                          disabled={disableUpOrder}
                          onClick={() => upOrderHandler(id)}
                        >
                          <FaArrowCircleUp />
                        </button>
                        <Tooltip
                          placement="top"
                          overlay={
                            <span>
                              {" "}
                              {subitem?.isActive
                                ? "Deactivate Menu"
                                : "Active Menu"}{" "}
                            </span>
                          }
                        >
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                              name="subitem?.isActive"
                              checked={subitem?.isActive}
                              onChange={(e) => activeSubmit(e)}
                              style={{ marginTop: "10px" }}
                            />
                          </div>
                        </Tooltip>
                      </>
                    )}
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Col>

        <Col></Col>
      </Row>
    </div>
  );
};

Subitem.propTypes = {
  subitem: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
//#endregion
export default memo(MenuItem);
